import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {UploadAssetRequestPref} from '../constants';

export const uploadAssetRequestEnabled = () =>
	getPreference(UploadAssetRequestPref.ENABLED, true);
